import { render, staticRenderFns } from "./badge-status.vue?vue&type=template&id=0ca4eee8&"
import script from "./badge-status.vue?vue&type=script&lang=js&"
export * from "./badge-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports